module.exports = __webpack_public_path__ + "img/lera-work-2.71f25083.webp";